export default {
  to: 'To:',
  transferTo: 'Transfer to',
  blindTransfer: 'Transfer',
  warmTransfer: 'Ask first',
  enterNameOrNumber: 'Enter Number',
  toVoicemail: 'To voicemail',
} as const;
